var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDebit = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 97,
  height: 96,
  viewBox: "0 0 97 96",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M76.5 80H20.5C13.872 80 8.5 74.628 8.5 68V28C8.5 21.372 13.872 16 20.5 16H76.5C83.128 16 88.5 21.372 88.5 28V68C88.5 74.628 83.128 80 76.5 80Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 52C39.756 52 25.244 52 24.5 52C22.292 52 20.5 53.792 20.5 56C20.5 58.208 22.292 60 24.5 60C25.244 60 39.756 60 40.5 60C42.708 60 44.5 58.208 44.5 56C44.5 53.792 42.708 52 40.5 52Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M88.5 32H8.5V44H88.5V32Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDebit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/debit.32962bcb.svg";
export { ForwardRef as ReactComponent };